/******************************************************************************
 * ApplicationFieldSelect: photo-category "champ d'application" selector.
 * A fixed 3-value enum (BEFORE / AFTER / BOTH) declaring which photo phase(s) the
 * category applies to. Static react-select (not AsyncSelect), mirroring
 * ContactTypeSelect, and sharing the photo-category react-select theme.
 *****************************************************************************/

/* Imports */
import { t } from "i18next";
import Select from "react-select";
import { reactSelectTheme } from "./reactSelectTheme";
/***/

const APPLICATION_FIELDS: EasyTech.PhotoApplicationField[] = ["BEFORE", "AFTER", "BOTH"];

const optionLabel = (value: EasyTech.PhotoApplicationField) =>
  t(`settings:photoCategories.applicationField.${value}`);

/**
 * ApplicationFieldSelect: photo-category application-field selector
 * @param value - current application field (defaults to BOTH when unset)
 * @param onChange - on change event
 * @param className - additional classNames
 */
export default function ApplicationFieldSelect({
  value,
  onChange,
  className = ""
}: {
  value?: EasyTech.PhotoApplicationField,
  onChange: (value: EasyTech.PhotoApplicationField) => void,
  className?: string
}) {
  const options = APPLICATION_FIELDS.map((v) => ({ value: v, label: optionLabel(v) }));
  const current = value || "BOTH";

  return (
    <div className={`${className}`}>
      <Select
        value={{ value: current, label: optionLabel(current) }}
        options={options}
        onChange={(e) => onChange((e?.value as EasyTech.PhotoApplicationField) || "BOTH")}
        className="w-full"
        classNamePrefix="react-select"
        theme={reactSelectTheme} />
    </div>
  );
}
/***/
